import httpClient from "../httpClient";

function getActiveAnnouncement() {
  return httpClient.get("/announcements/active");
}

function getAllAnnouncements(params = {}) {
  return httpClient.get("/announcements", { params });
}

function createAnnouncement(data) {
  return httpClient.post("/announcements", data);
}

function updateAnnouncement(id, data) {
  return httpClient.patch(`/announcements/${id}`, data);
}

function expireAnnouncement(id) {
  return httpClient.patch(`/announcements/${id}/expire`);
}

function deleteAnnouncement(id) {
  return httpClient.delete(`/announcements/${id}`);
}

export default {
  getActiveAnnouncement,
  getAllAnnouncements,
  createAnnouncement,
  updateAnnouncement,
  expireAnnouncement,
  deleteAnnouncement,
};
